import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LangService } from 'src/app/service/lang.service';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
  private subscriptions: Subscription;
  dir: string = '';

  constructor(public translate: TranslateService, public langser: LangService) {
    this.subscriptions = this.langser.getData().subscribe(value => {
      this.setValue(value);
    });
  }

  ngOnInit(): void {
    const lang = this.langser.getLang();
    this.setValue(lang);
  }

  setValue(lang: string) {
    this.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
